import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetEdc_sharing_groupIdInvoicesExport = z.any()
export type TagsGetEdc_sharing_groupIdInvoicesExport = z.infer<typeof tagsGetEdc_sharing_groupIdInvoicesExport>

export const paramsGetEdc_sharing_groupIdInvoicesExport = z.object({ "groupId": z.string() })
export type ParamsGetEdc_sharing_groupIdInvoicesExport = z.infer<typeof paramsGetEdc_sharing_groupIdInvoicesExport>

export const responseGetEdc_sharing_groupIdInvoicesExport = z.any()
export type ResponseGetEdc_sharing_groupIdInvoicesExport = z.infer<typeof responseGetEdc_sharing_groupIdInvoicesExport>

interface IGetEdc_sharing_groupIdInvoicesExport extends BaseMethodType {
  tags: TagsGetEdc_sharing_groupIdInvoicesExport,
  params: ParamsGetEdc_sharing_groupIdInvoicesExport,
  response: ResponseGetEdc_sharing_groupIdInvoicesExport
}
export const URL = '/edc-sharing/:groupId/invoices/export'
export const validation = {
  get: {
    tags: tagsGetEdc_sharing_groupIdInvoicesExport,
    params: paramsGetEdc_sharing_groupIdInvoicesExport,
    response: responseGetEdc_sharing_groupIdInvoicesExport
  }
}
export interface Edc_sharing_groupIdInvoicesExport extends BaseRouteType {
  get: IGetEdc_sharing_groupIdInvoicesExport
}